import React from "react";
import PlusMinButtons from "../../../common/PlusMinButtons";
import TextInput from "../../../common/TextInput";
import NumberInput from "../../../common/NumberInput";
import Row from "../../../common/Row";
import PropTypes from "prop-types";

const DeelnamePrijzenComponent = props => {
	const {
		omschrijving,
		prijs,
		minButtonEnabled,
		plusButtonEnabled,
		disabled,
		onPlusButtonClick,
		onMinButtonClick,
		onChange,
		index,
		errors,
		validationMessageType
	} = props;

	return (
		<Row>
			<TextInput
				name={"omschrijving_" + index}
				label={"omschrijving deelnameprijs"}
				size={6}
				value={omschrijving}
				onChange={onChange}
				validationMessage={errors ? errors["omschrijving"] : ""}
				validationMessageType={validationMessageType}
				disabled={disabled}
				tooltip="hier kun je per categorie de deelnameprijs vermelden. Bv. Leden, niet-leden, ..."
			/>
			<NumberInput
				name={"prijs_" + index}
				label={"deelnameprijs"}
				value={prijs}
				onChange={onChange}
				isValuta
				size={4}
				validationMessage={errors ? errors["prijs"] : ""}
				validationMessageType={validationMessageType}
				disabled={disabled}
				tooltip="Gelieve 0 € in te vullen als de tocht gratis is"
			/>
			<PlusMinButtons
				minButtonEnabled={minButtonEnabled && !disabled}
				plusButtonEnabled={plusButtonEnabled && !disabled}
				onMinButtonClick={onMinButtonClick}
				onPlusButtonClick={onPlusButtonClick}
				size={1}
			/>
		</Row>
	);
};

DeelnamePrijzenComponent.propTypes = {
	omschrijving: PropTypes.string,
	prijs: PropTypes.number,
	minButtonEnabled: PropTypes.bool,
	plusButtonEnabled: PropTypes.bool,
	disabled: PropTypes.bool,
	onPlusButtonClick: PropTypes.func.isRequired,
	onMinButtonClick: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	index: PropTypes.number,
	errors: PropTypes.object,
	validationMessageType: PropTypes.string
};

export default DeelnamePrijzenComponent;
